<template lang='pug'>
section
  ckeditor(
    v-model='html'
    :config='config'
    :upload-adapter='uploadAdapter'
    type='classic'
  )
</template>

<script>
import Vue from 'vue'
import http from '@/http'
import config from '@/config'
import emitter from '@/emitter'

import VueCkeditor from 'vue-ckeditor5'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

import '@ckeditor/ckeditor5-build-classic/build/translations/ru.js'

Vue.use(VueCkeditor.plugin, {
  editors: {
    classic: ClassicEditor
  },
  name: 'ckeditor'
})

export default {
  props: ['value'],

  data: () => ({
    html: '',
    config: {
      toolbar: {
        viewportTopOffset: 64,
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'bulletedList',
          'numberedList',
          'insertTable',
          'blockQuote',
          'imageUpload'
        ]
      },
      image: {
        toolbar: [
          'imageTextAlternative',
          '|',
          'imageStyle:alignLeft',
          'imageStyle:full',
          'imageStyle:alignRight'
        ],
        styles: ['full', 'alignLeft', 'alignRight']
      },
      language: 'ru'
    },
    uploadAdapter: function(loader) {
      this.upload = () => {
        let body = new FormData()
        body.append('editor', loader.file)

        return http
          .post(`${config.baseURL}/files/upload/ckeditor`, body)
          .then(response => {
            return {
              default: response.data.url
            }
          })
          .catch(() => emitter.$emit('ckeditor.error'))
      }

      this.abort = () => {
        emitter.$emit('ckeditor.abort')
      }
    }
  }),

  created() {
    this.html = this.value
    emitter.$on('ckeditor.error', this.onFileUploadError)
  },

  beforeDestroy() {
    emitter.$off('ckeditor.error', this.onFileUploadError)
  },

  methods: {
    onFileUploadError() {
      this.$nextTick(() => this.$root.showSnack('Ошибка загрузки файла'))
    }
  },

  watch: {
    value(val) {
      this.html = val
    },

    html(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
section >>> .ck-editor__editable {
  min-height: 200px;
}
</style>
